"use strict";
const _ = require('lodash');
_.mixin(require('lodash-uuid'));
module.exports = entity => {
    const ensuredEntity = {
        ...entity,
    };
    ensuredEntity.purchaseListItems = (ensuredEntity.purchaseListItems || []).map(entry => ({
        ...entry,
        id: `${entity.id}-${_.get(entry, 'article.id', _.uuid())}`,
    }));
    return ensuredEntity;
};
